module.exports = __webpack_public_path__ + "4e7a763372d536746b2a6f0e541dae5c.jpg";